import EventDispatcher from '../../../../../shared/lib/html5-software-library/src/ranj/util/EventDispatcher';

export default class PuzzleModel extends EventDispatcher {


    constructor(location, allowFail, successFeedback, time, ruleId, sequence, ordered, hasNextSequence, correctInput) {
        super();
        this._location = location;
        this._allowFail = allowFail;
        this._successFeedback = successFeedback;
        this._hasNextSequence = hasNextSequence;
        this._sequence = sequence;
        this._ordered = ordered;
        this._ruleId = ruleId;
        this._correctInput = correctInput;
        this.time = time;
        this.reset();
    }

    get location() {
        return this._location;
    }

    get successFeedback() {
        return this._successFeedback;
    }

    get hasNextSequence() {
        return this._hasNextSequence;
    }

    get sequence() {
        return this._sequence;
    }

    get ruleId() {
        return this._ruleId;
    }

    get allowFail() {
        return this._allowFail;
    }

    get correctInput() {
        return this._correctInput;
    }

    pickSpot(spot) {
        this._pickedSpots.push(spot);
    }

    unpickSpot(spot) {
        this._pickedSpots.remove(spot);
    }

    get sampleFishVariation() {
        var ruleIdLastChar = this.ruleId.slice(this.ruleId.length - 1);
        if ("ABCDEF".includes(ruleIdLastChar)) {
            return { amount: 1, pattern: ruleIdLastChar };
        } else {
            return null;
        }
    }

    get pickedSpots() {
        return this._pickedSpots;
    }

    get lastPickedSpot() {
        if (this._pickedSpots.length < 1) { return null };

        return this._pickedSpots[this._pickedSpots.length - 1];
    }

    reset() {
        this._pickedSpots = [];
    }


    validate() {
        //Just compare picked with required
        const picked = this._pickedSpots.map(spot => spot.id);
        const required = this._correctInput.slice();//duplicate because we change the array
        //  Sort both lists in the same way, if order is not important
        if (!this._ordered) {
            picked.sort((s1, s2) => s1 - s2);
            required.sort((s1, s2) => s1 - s2);
        }
        return picked.join(",") == required.join(",");
    }

}